import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { HashRouter as Router, Route, Routes, useLocation, Link, Navigate, useParams } from 'react-router-dom';
import { tdSynnexTheme } from './styles/theme';
import { Layout, Menu, Button, Typography, ConfigProvider } from 'antd';
import { HomeOutlined, QuestionOutlined, LogoutOutlined, CompassOutlined, BarsOutlined } from '@ant-design/icons';
import logo from './assets/TD_SYNNEX_logo_file.png';
import Locations from "./components/Locations";
import Reports from "./components/Reports";
import './styles/App.css';
import reportKeys from "./components/reportKeys"
import AppInsightsPageViews from "./components/AppInsightsPageViews";
import { trackException } from "./utils/appInsights";

const loginScopes = ["openid", "profile", "email"];
const powerBiScope = [process.env.REACT_APP_AZURE_POWER_BI_SCOPE];

  const { Header, Content, Footer } = Layout;
  const { Text } = Typography;
  const AppNavigation = ({logout, isAuthenticated }) => {
  const location = useLocation();
  
    const getSelectedKey = () => {
      const path = location.pathname;
      if (path.startsWith('/locations')) return 'sites';
      if (path.startsWith('/reports')) return 'reports';
      if (path === '/help') return 'help';
      return 'home';
    };
    
    const menuItems = [
      {
        key: 'home',
        icon: <HomeOutlined />,
        label: <a href="#/">Home</a>,
      },
      {
        key: 'sites',
        icon: <BarsOutlined />,
        label: 'Locations',
        children: [
          { key: 'suwanee',    label: <Link to="/locations/suwanee">Suwanee / GA</Link> },
          { key: 'swedesboro', label: <Link to="/locations/swedesboro">Swedesboro / NJ</Link> },
          { key: 'south-bend', label: <Link to="/locations/south-bend">South Bend / IN</Link> },
          { key: 'ft-worth',   label: <Link to="/locations/ft-worth">Ft. Worth / TX</Link> },
          { key: 'fontana',    label: <Link to="/locations/fontana">Fontana / CA</Link> },
          { key: 'romeoville', label: <Link to="/locations/romeoville">Romeoville / IL</Link> },
          { key: 'southaven',  label: <Link to="/locations/southaven">Southaven / MS</Link> },
          { key: 'chino',      label: <Link to="/locations/chino">Chino / CA</Link> },
        ],
      },
      {
        key: 'reports',
        icon: <CompassOutlined />,
        label: <Link to="/reports">Reports</Link>,
        children: [
          { key: 'no-read',                   label: <Link to="/reports/no-read">No Read</Link> },
          { key: 'weight-failure',            label: <Link to="/reports/weight-failure">Weight Failure</Link> },
          
          /*{ key: 'xpak',                      label: <Link to="/reports/xpak">XPAK</Link> },
          { key: 'effectiveness-print-apply', label: <Link to="/reports/effectiveness-print-apply">Effectiveness of Print &amp; Apply</Link> },
          { key: 'box-creation-analysis',     label: <Link to="/reports/box-creation-analysis">Box Creation Analysis</Link> },
          { key: 'opex',                      label: <Link to="/reports/opex">Opex</Link> },
          { key: 'scanner-analysis',          label: <Link to="/reports/scanner-analysis">Scanner Analysis</Link> },  
          { key: 'xpak-duplicates',           label: <Link to="/reports/xpak-duplicates">XPAK Duplicates</Link> },
          { key: 'iwarehouse-reporting',      label: <Link to="/reports/iwarehouse-reporting">iWarehouse Reporting</Link> },*/
        ],
      },
      {
        key: 'help',
        icon: <QuestionOutlined />,
        label: <a href="#/help">Help/FAQ</a>,
      },
      ...(isAuthenticated ? [{
        key: 'logout',
        label: (
          <Button
            type="primary"
            icon={<LogoutOutlined />}
            onClick={logout}
            size="small"
          >
            Logout
          </Button>
        )
      }] : [])
    ];
  
    return (
      <Header style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 20px',
        height: '65px'
      }}>
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <img src={logo} alt="TD SYNNEX Logo" style={{ height: '65px', marginRight: '20px' }} />
          <Menu
            theme="light"
            mode="horizontal"
            selectedKeys={[getSelectedKey()]}
            items={menuItems}
            style={{
              flex: 1,
              minWidth: 0,
              backgroundColor: "transparent",
              border: "none",
              height: "65px",
              lineHeight: "65px",
            }}
          />
        </div>
      </Header>
    );
  };

const SITES = {
  "suwanee":     { label: "Suwanee / GA",     url: "https://suwanee.tdsnx.tdsynnex.com/dash.aspx" },
  "swedesboro":  { label: "Swedesboro / NJ",  url: "https://Swedesboro.tdsnx.tdsynnex.com/dash.aspx" },
  "south-bend":  { label: "South Bend / IN",  url: "https://southbend.tdsnx.tdsynnex.com/dash.aspx" },
  "ft-worth":    { label: "Ft. Worth / TX",   url: "https://ftworth.tdsnx.tdsynnex.com/dash.aspx" },
  "fontana":     { label: "Fontana / CA",     url: "https://fontana.tdsnx.tdsynnex.com/dash.aspx" },
  "romeoville":  { label: "Romeoville / IL",  url: "https://Romeoville.tdsnx.tdsynnex.com/dash.aspx" },
  "southaven":   { label: "Southaven / MS",   url: "https://Southaven.tdsnx.tdsynnex.com/dash.aspx" },
  "chino":       { label: "Chino / CA",       url: "https://chino.tdsnx.tdsynnex.com/dash.aspx" },
  }


  export default function App() {
  const { instance, accounts, inProgress } = useMsal();
  const [pbiToken, setPbiToken] = useState(null); 

  useEffect(() => {
    const ensureLogin = async () => {
      if (accounts.length === 0) {
        try {
          await instance.ssoSilent({ scopes: loginScopes });
        } catch {
          await instance.loginRedirect({ scopes: loginScopes });
        }
      }
    };
    if (inProgress === InteractionStatus.None && accounts.length === 0) {
      ensureLogin();
    }
  }, [inProgress, accounts, instance]);

  useEffect(() => {
    const getToken = async () => {
      if (accounts.length > 0) {
        console.log({accounts});
        try {
          const resp = await instance.acquireTokenSilent({
            scopes: powerBiScope,
            account: accounts[0],
          });
          setPbiToken(resp.accessToken);
        } catch (error) {
          console.warn("Power BI token silent acquisition failed:", error);
          setPbiToken(null);
          trackException(error, {
            context: "PowerBiTokenSilent",
            errorCode: error?.errorCode,
            subError: error?.subError,
          });
        }
      }
    };
    if (inProgress === InteractionStatus.None) {
      getToken();
    }
  }, [inProgress, accounts, instance]);

  function LocationsRoute() {
    const { id } = useParams(); 
    const exists = id && SITES[id];
    if (!exists) {
      return <Navigate to="/locations/suwanee" replace />; 
    }
    return (
      <div style={{ height: 'calc(100vh - 65px - 72px)' }}>
        <Locations siteId={id} sites={SITES} />
      </div>
    );
  }
  function ReportsRoute() {
    const { key } = useParams();
    const reportConfig = key ? reportKeys[key] : null;
    if (!reportConfig) {
        const firstKey = Object.keys(reportKeys)[0] || "no-read";
        return <Navigate to={`/reports/${firstKey}`} replace />;
    }
    return (
      <Reports
        accessToken={pbiToken}
        reportId={reportConfig.reportId}
        groupId={reportConfig.groupId}
        reportKey={key}
        filters={reportConfig.filters}
      />
    );
  }
  const firstReportKey = Object.keys(reportKeys)[0] || "no-read";
  return (
        <ConfigProvider theme={tdSynnexTheme}>
        <Router>
          <AppInsightsPageViews />
          <Layout style={{ minHeight: '100vh' }}>
            <AppNavigation/>
  
            <Content style={{
              padding: '20px',
              backgroundColor: '#f4f4f4'
            }}>
              <Routes>
                <Route path="/locations/:id" element={<LocationsRoute />} />
                
                <Route path="/reports" element={<Navigate to={`/reports/${firstReportKey}`} replace />} />
             
                <Route path="/reports/:key" element={<ReportsRoute />} />

                <Route path="/" element={<div>Welcome Home</div>} />
              </Routes>
            </Content>
  
            <Footer style={{
              textAlign: 'center',
              backgroundColor: 'rgb(232, 239, 243)',
              color: '#003366',
              padding: '10px 20px'
            }}>
              <Text style={{ color: '#003366' }}>
                &copy; 2025 Shyft Global Services. All rights reserved.
              </Text>
            </Footer>
          </Layout>
        </Router>
      </ConfigProvider>
  );
}
